import React from "react";
import CTAButton from "../Buttons/CTAButton/CTAButton";
import ContentImage from "../../assets/images/Content Image.png";
import ContentSectionDesktop from "./ContentSectionDesktop";
import ContentSectionMobile from "./ContentSectionMobile";

const ContentSection = () => {
  return (
    <div>
      <section className="bg-white dark:bg-gray-900">
        <div className="hidden lg:block">
    <ContentSectionDesktop/>
        </div>
        <div className="lg:hidden">

    <ContentSectionMobile/>
        </div>
      </section>
    </div>
  );
};

export default ContentSection;